export enum BuildSignatureRequestType {
    MESSAGE = 'MESSAGE',
    EIP712 = 'EIP712',
}
